import React, { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import "./SinglePercentFilter.scss";

import { PercentInput } from "src/app/components/MaskedInputs/PercentInput";
import { valueExists } from "src/app/methods/valueExists";
import { translateMessage } from "src/app/methods/translateMessage";
import { DictionaryFiltersContext } from "../../DictionaryFilters";

export function SinglePercentFilter({ col, setWaitEvent }) {
  const intl = useIntl();
  const { dictionaryFilters } = useContext(DictionaryFiltersContext);
  const { filters } = dictionaryFilters;

  const [value, setValue] = useState(filters[col.uuid]?.value.from);
  const [value2, setValue2] = useState(filters[col.uuid]?.value.to);

  useEffect(() => {
    (value !== undefined || value2 !== undefined) &&
      (value !== filters[col.uuid]?.value.from ||
        value2 !== filters[col.uuid]?.value.to) &&
      setWaitEvent({
        target: {
          value:
            !valueExists(value) && !valueExists(value2)
              ? undefined
              : { from: value, to: value2 },
        },
      });
  }, [value, value2]);

  return (
    <div className="single-percent-filter">
      <PercentInput
        className="single-percent-filter__input"
        rawValue={value}
        setRawValue={setValue}
        placeholder={translateMessage({
          intl,
          id: "ws_from",
          defaultMessage: "From",
        })}
        data-qa={`${col.name}-from`}
      />
      <PercentInput
        className="single-percent-filter__input"
        rawValue={value2}
        setRawValue={setValue2}
        placeholder={translateMessage({
          intl,
          id: "ws_to",
          defaultMessage: "To",
        })}
        data-qa={`${col.name}-to`}
      />
    </div>
  );
}
